'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Fallback = require('../base/Fallback');

var _Fallback2 = _interopRequireDefault(_Fallback);

var _ButtonClear = require('../button/ButtonClear');

var _ButtonClear2 = _interopRequireDefault(_ButtonClear);

var _BaseCombobox2 = require('../combobox/BaseCombobox');

var _BaseCombobox3 = _interopRequireDefault(_BaseCombobox2);

var _MenuList = require('../combobox/MenuList');

var _MenuList2 = _interopRequireDefault(_MenuList);

var _IconComponent = require('../icon/IconComponent');

var _IconComponent2 = _interopRequireDefault(_IconComponent);

var _language = require('../language');

var _UtilApi = require('../utils/UtilApi');

var _UtilLodash = require('../utils/UtilLodash');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loadable = _component2.default.lib(function () {
  return import("../lib/react-select/dist/react-select.esm");
});


var ClearIndicator = function ClearIndicator(props) {
  var _props$innerProps = props.innerProps,
      ref = _props$innerProps.ref,
      restInnerProps = (0, _objectWithoutProperties3.default)(_props$innerProps, ['ref']);

  return _react2.default.createElement(_ButtonClear2.default, (0, _extends3.default)({}, restInnerProps, { ref: ref }));
};

var createOption = function createOption(label) {
  return {
    label: label,
    value: label
  };
};

var IDTag = function (_BaseCombobox) {
  (0, _inherits3.default)(IDTag, _BaseCombobox);

  function IDTag(props) {
    (0, _classCallCheck3.default)(this, IDTag);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDTag.__proto__ || (0, _getPrototypeOf2.default)(IDTag)).call(this, props));

    _this.convertValue = function (value) {
      return value;
    };

    _this.handleChange = function (value) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      if ((0, _UtilLodash.checkIsEmpty)(value)) {
        _this.setValue(null);
      } else {
        _this.setValue(value);
      }
    };

    _this.handleInputChange = function (inputValue) {
      if (inputValue) {
        _this.Placeholder && _this.Placeholder.hidden();
      } else {
        _this.Placeholder && _this.Placeholder.show();
      }

      if (_this.props.maxInputLength && inputValue.length > _this.props.maxInputLength) {
        return;
      }

      if (!(0, _UtilLodash.checkIsEmpty)(inputValue) && (inputValue.indexOf(",") >= 0 || inputValue.indexOf(";") >= 0)) {
        var splits = [];
        if (inputValue.indexOf(",") >= 0) {
          splits = inputValue.split(",");
        } else if (inputValue.indexOf(";") >= 0) {
          splits = inputValue.split(";");
        }
        var value = _this.state.value;

        var results = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(splits), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var split = _step.value;

            if (!(0, _UtilLodash.checkIsEmpty)(split)) {
              results.push(createOption(split));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.setState({
          inputValue: ''
        }, function () {
          _this.handleChange([].concat((0, _toConsumableArray3.default)(value || []), results));
        });
      } else {
        _this.setState({ inputValue: inputValue });
      }
    };

    _this.handleKeyDown = function (event) {
      var _this$state = _this.state,
          inputValue = _this$state.inputValue,
          value = _this$state.value;


      if (!inputValue) return;
      switch (event.key) {
        case ',':
        case ';':
          _this.setState({
            inputValue: ''
          }, function () {
            _this.handleChange([].concat((0, _toConsumableArray3.default)(value || []), [createOption(inputValue || '')]));
          });
          event.preventDefault();
          break;
        default:
          break;
      }
    };

    _this.state = {
      inputValue: "",
      options: (0, _UtilApi.getProxy)(props) ? [] : _this.convertData(props.options),
      value: !_this.checkIsEmptyOrNull(props.value) ? props.value : props.defaultValue
    };
    _this.dataTestID = 'tag';
    return _this;
  }

  (0, _createClass3.default)(IDTag, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var proxy = (0, _UtilApi.getProxy)(this.props);
      if (proxy) {
        this.loadData(proxy, function (options) {
          _this2.setState({
            options: options
          });
        });
      }
    }
  }, {
    key: 'setData',
    value: function setData(options, value) {
      this.setState({ options: options, value: value });
    }
  }, {
    key: 'getComponents',
    value: function getComponents() {
      var _props = this.props,
          visibleIcon = _props.visibleIcon,
          virtualized = _props.virtualized,
          iconCls = _props.iconCls,
          iconType = _props.iconType,
          iconLine = _props.iconLine;

      if (virtualized) {
        return {
          ClearIndicator: ClearIndicator,
          DropdownIndicator: function DropdownIndicator() {
            return visibleIcon ? _react2.default.createElement(_IconComponent2.default, {
              iconCls: iconCls,
              iconType: iconType,
              iconLine: iconLine
            }) : null;
          },
          IndicatorSeparator: '',
          MenuList: _MenuList2.default
        };
      }
      return {
        ClearIndicator: ClearIndicator,
        DropdownIndicator: function DropdownIndicator() {
          return visibleIcon ? _react2.default.createElement(_IconComponent2.default, {
            iconCls: iconCls,
            iconType: iconType,
            iconLine: iconLine
          }) : null;
        },
        IndicatorSeparator: ''
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          className = _props2.className,
          style = _props2.style,
          disabled = _props2.disabled,
          isClearable = _props2.isClearable,
          isSearchable = _props2.isSearchable,
          readOnly = _props2.readOnly,
          autoFocus = _props2.autoFocus,
          isMulti = _props2.isMulti,
          filterOption = _props2.filterOption;
      var _state = this.state,
          options = _state.options,
          inputValue = _state.inputValue,
          value = _state.value;

      var commonProps = (0, _extends3.default)({}, this.props, {
        value: value,
        options: options || [],
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        className: undefined
      });

      return _react2.default.createElement(
        'div',
        {
          'data-testid': this.getDataTestId(),
          className: (0, _classnames2.default)('tag body-wrap', className, { 'input-disabled': disabled, 'read-only': readOnly }),
          style: style
        },
        _react2.default.createElement(
          Loadable,
          { fallback: _react2.default.createElement(_Fallback2.default, null) },
          function (_ref) {
            var Creatable = _ref.Creatable,
                createFilter = _ref.createFilter;
            return _react2.default.createElement(Creatable, (0, _extends3.default)({
              isMulti: isMulti,
              isClearable: disabled === true ? false : isClearable,
              isSearchable: isSearchable,
              components: _this3.getComponents(),
              formatCreateLabel: function formatCreateLabel(label) {
                return (0, _language.t)('Create') + ' "' + label + '"';
              },
              openOnFocus: true,
              autoFocus: autoFocus,
              filterOption: filterOption || createFilter({ ignoreAccents: false }),
              styles: {
                option: function option(provided) {
                  return (0, _extends3.default)({}, provided, {
                    padding: '5px 8px',
                    cursor: 'pointer'
                  });
                },
                menuList: function menuList(provided) {
                  return (0, _extends3.default)({}, provided, {
                    padding: 0
                  });
                }
              }
            }, commonProps, {
              options: options,
              placeholder: '',
              inputValue: inputValue,
              onInputChange: _this3.handleInputChange,
              onKeyDown: _this3.handleKeyDown
            }));
          }
        ),
        this.renderPlaceholder()
      );
    }
  }]);
  return IDTag;
}(_BaseCombobox3.default);

exports.default = IDTag;


IDTag.defaultProps = (0, _assign2.default)({}, _BaseCombobox3.default.defaultProps, {
  iconCls: '',
  iconType: 'plus-square',
  isSearchable: true,
  visibleIcon: true,
  isClearable: true,
  isMulti: true,
  placeholder: "Input...",
  virtualized: true
});